module.exports = __webpack_public_path__ + "img/avatar-9.afbf4a78.jpeg";